if (!window.Eurus.loadedScript.has('quantity-selector.js')) {
  window.Eurus.loadedScript.add('quantity-selector.js');

  function getPurchaseLimitRemaining(productId) {
    var el = document.getElementById('PurchaseLimitRules');
    if (!el) return Infinity;
    var rules;
    try {
      rules = JSON.parse(el.textContent);
    } catch (e) {
      return Infinity;
    }
    var rule = (rules || []).find(function (r) {
      return r.active && String(r.product_id) === String(productId);
    });
    if (!rule) return Infinity;
    var inCart = (window.PurchaseLimitCartQty && window.PurchaseLimitCartQty[productId]) || 0;
    return Math.max(0, rule.limit - rule.purchased - inCart);
  }

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xQuantitySelector', (
        productId,
        sectionId,
        qtyRuleMin,
        qtyRuleMax,
        isQtyRule,
        currencyCodeEnable,
        moneyWithCurrency,
        moneyFormat
      ) => ({
        qty: qtyRuleMin,
        min: qtyRuleMin,
        max: qtyRuleMax,
        initQtyChangeEvent(selector) {
          this.$nextTick(() => { 
            this.qty = document.getElementById(selector)?.value;
            document.addEventListener(`eurus:product:quantity-changed-${sectionId}`, (e) => {
              this.qty = e.detail.quantity;
            })
          });
        },
        minus(value) {
          if(this.qty <= this.min) {
            this.qty = this.min;
          } else {
            this.qty = parseInt(this.qty);
            (this.qty == 1) ? this.qty = 1 : this.qty -= value;
          }
          this.updatePrice();
        },
        plus(value) {
          const limitRemaining = getPurchaseLimitRemaining(productId);
          const effectiveMax = isQtyRule ? Math.min(this.max, limitRemaining) : limitRemaining;
          const capped = isQtyRule || limitRemaining !== Infinity;

          if(this.qty >= effectiveMax && capped) {
            if (limitRemaining !== Infinity && limitRemaining <= effectiveMax && window.showPurchaseLimitToast) {
              window.showPurchaseLimitToast(window.Eurus.purchase_limit_capped_html.replace('[quantity]', limitRemaining));
            }
            this.qty = parseInt(effectiveMax);
          } else {
            this.qty = parseInt(this.qty);
            this.qty += value;
          }
          this.updatePrice();
        },
        invalid(el) {
          number = parseFloat(el.value);
          if (!Number.isInteger(number) || number < this.min) {
            this.qty = this.min;
          }
          const limitRemaining = getPurchaseLimitRemaining(productId);
          const effectiveMax = isQtyRule ? Math.min(this.max, limitRemaining) : limitRemaining;
          const capped = isQtyRule || limitRemaining !== Infinity;

          if (number > effectiveMax && capped) {
            if (limitRemaining !== Infinity && limitRemaining <= effectiveMax && window.showPurchaseLimitToast) {
              window.showPurchaseLimitToast(window.Eurus.purchase_limit_capped_html.replace('[quantity]', limitRemaining));
            }
            this.qty = parseInt(effectiveMax);
          }
          this.updatePrice();
        },
        updatePrice() {
          const product_template = document.getElementById(`x-product-template-${productId}-${sectionId}`);
          const money_format = currencyCodeEnable ? moneyWithCurrency : moneyFormat;

          const getPrice = (selector) => {
            return Number(product_template.querySelector(selector).innerHTML) * this.qty;
          };
          const update = (selector, value) => {
            const el = product_template.querySelector(selector);
            if (el) el.innerHTML = value;
          };

          let product_price = Alpine.store('xHelper').formatMoney(getPrice('.target-price'), money_format);
          let product_compare_at_price = Alpine.store('xHelper').formatMoney(getPrice('.target-compare-at-price'), money_format);

          update('.add_to_cart_button .main-product-price .price', product_price);
          update('.add_to_cart_button .main-product-price .price-sale', product_price);
          update('.add_to_cart_button .main-product-price .price-compare', product_compare_at_price);
        }
      }));
    })
  });
}    